import React from 'react';
import {
	styled,
	ParentBoundComponent,
	Module
} from 'ps-gui';

import {
	CellMainText,
	CellSubText
} from './portalresultsetmodule';

import SystemMaintenanceModel from './systemmaintenancemodel';

const Wrapper = styled.div`
`;

export default class SystemMaintenanceModule extends ParentBoundComponent {

	getModel() {
		return new SystemMaintenanceModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(this.getModel().initialize());
		}
	}

	render() {
		const data = this.getData();
		return (
			<Wrapper>
				<Module
					appState={data.get('esad')}
					onDataChange={newData => {
						this.setData(data.setIn(['esad', 'data'], newData));
					}}
					customResultProps={customResultProps}
				/>
			</Wrapper>
		);
	}
}

const cellRendererMap = Object.freeze({
	'maintenance': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('from_time') + ' - ' + row.get('to_time')}</CellSubText>
			</>
		);
	},
	'created_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('created_by')}</CellSubText>
			</>
		);
	},
	'edited_when': (cell, row, colIndex) => {
		return (
			<>
				<CellMainText>{cell}</CellMainText>
				<CellSubText>{row.get('edited_by')}</CellSubText>
			</>
		);
	},
});

const customResultProps = {
	cellRendererMap,
	withNewEntityButton: true,
	withRowSelection: true,
	columnFilters: {
		'is_deleted': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'is_active': {
			type: 'lookup',
			lookup: 'ynBoolean'
		},
		'comments': {
			type: 'text',
		},
		'maintenance': {
			type: 'date'
		},
		'notification_from_date': {
			type: 'date'
		},
		'created_when': {
			type: 'date'
		},
		'edited_when': {
			type: 'date'
		},
	}
};

